export default defineNuxtPlugin(() => {
  return {
    provide: {
      format: {
        uppercase(val) {
          if (!val) return "";
          return val.toUpperCase();
        },
        capitalize(string) {
          if (!string) return "";
          return string.charAt(0).toUpperCase() + string.slice(1);
        },
        price(number, digits = 2) {
          if (typeof number !== "undefined") {
            try {
              return (
                "€ " +
                Number(number)
                  .toFixed(digits)
                  .replace(".", ",")
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
              );
            } catch (e) {
              // console.warn("Error formatting price:", number);
              return "";
            }
          }
          return "";
        },
        float(number, digits = 2) {
          if (typeof number !== "undefined") {
            try {
              return Number(number).toFixed(digits).replace(".", ",");
            } catch (e) {
              // console.warn("Error formatting float:", number);
              return "";
            }
          }
          return "";
        },
        percentage(number, digits = 2) {
          if (typeof number !== "undefined") {
            try {
              return Number(number).toFixed(digits).replace(".", ",") + "%";
            } catch (e) {
              // console.warn("Error formatting percentage:", number);
              return "";
            }
          }
          return "";
        },
        address(item) {
          if (typeof item !== "undefined" && item.address) {
            try {
              const identifier = item.identifier
                ? `#${item.identifier} - `
                : "";
              const street_number = item.address.street_number
                ? `, ${item.address.street_number}`
                : "";

              return `${identifier}${item.address.street}${street_number} ${item.address.city
                } (${item.address.province.toUpperCase()})`;
            } catch (e) {
              // console.warn("Error formatting address:", item);
              return "";
            }
          }
          return "";
        },
        address_simple(address) {
          if (typeof address !== "undefined" && address) {
            try {
              const street_number = address.street_number
                ? `, ${address.street_number}`
                : "";

              return `${address.street}${street_number} ${address.city
                } (${address.province.toUpperCase()})`;
            } catch (e) {
              // console.warn("Error formatting address_simple:", address);
              return "";
            }
          }
          return "";
        },
        full_address(item) {
          if (typeof item !== "undefined") {
            try {
              const street_number = item.street_number
                ? `, ${item.street_number}`
                : "";

              return `${item.street}${street_number} ${item.city
                } (${item.province.toUpperCase()})`;
            } catch (e) {
              // console.warn("Error formatting full_address:", item);
              return "";
            }
          }
          return "";
        },
        address_no_id(item) {
          if (typeof item !== "undefined" && item.address) {
            try {
              const street_number = item.address.street_number
                ? `, ${item.address.street_number}`
                : "";

              return `${item.address.street}${street_number} ${item.address.city
                } (${item.address.province.toUpperCase()})`;
            } catch (e) {
              // console.warn("Error formatting address_no_id:", item);
              return "";
            }
          }
          return "";
        },
        striphtml(value) {
          if (!value) return "";
          return value.replace(/<[^>]*>?/gm, "");
        },
      },
    },
  };
});
